module.exports = __webpack_public_path__ + "img/002.e8a78b75.png";